import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "head"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 0,
    class: "mt-2"
};
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
import CategoryButton from './elements/CategoryButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCategories',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCategories, getAvailableVouchers, getCustomerVouchers, addCustomerFavouriteDiscount, removeCustomerFavouriteDiscount, removeUnavailableDiscountProviders } = useVouchers();
        const filter = ref(route.query.filters ?? null);
        const filterCount = ref(0);
        const title = ref(route.query.title ?? "Categories");
        const image = ref(route.query.image ?? null);
        const favourites = ref(false);
        const favouriteVouchers = ref(null);
        const activeCategories = ref(null);
        function navFilter(o) {
            router.push({ path: '/vouchers', query: o });
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            getCategories(() => {
                activeCategories.value = state.categories.filter((c) => c.active);
            });
            getCustomer();
            getAvailableVouchers(() => {
                favouriteVouchers.value = state.availableVouchers.filter((v) => v.favourite);
                state.availableVouchers.forEach((v) => {
                    removeUnavailableDiscountProviders(v);
                });
            });
            getCustomerVouchers();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: title.value,
                    border: image.value ? 0 : null,
                    bgcolor: image.value ? '#281C3Bff' : 'white',
                    color: image.value ? 'white' : null
                }, null, 8, ["title", "border", "bgcolor", "color"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (filter.value && _unref(state).availableVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "header",
                                    style: _normalizeStyle('background-image: url(' + image.value + ')')
                                }, [
                                    _createVNode(_component_v_row, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_col, { class: "v-col-7 title-col" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("h1", null, _toDisplayString(title.value), 1)
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_col, { class: "v-col-5 chip-col" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_chip, {
                                                        color: "white",
                                                        variant: "flat"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(filterCount.value) + " card(s)", 1)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ], 4)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(VoucherList, {
                                    showFavourites: true,
                                    onFavouriteToggled: _cache[0] || (_cache[0] = (v) => { favouriteToggled(v); }),
                                    onOnFilterApplied: _cache[1] || (_cache[1] = (count) => { filterCount.value = count; }),
                                    categories: filter.value,
                                    showAll: false,
                                    vouchers: _unref(state).availableVouchers,
                                    search: false
                                }, null, 8, ["categories", "vouchers"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (!favourites.value && !filter.value && activeCategories.value && _unref(state).availableVouchers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCategories.value, (c) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass('hubItemWrapper'),
                                    key: c.id
                                }, [
                                    _createVNode(CategoryButton, {
                                        onClick: ($event) => { navFilter({ title: c.pageTitle, filters: c.providerFilters, image: c.pageImage }); },
                                        image: c.buttonImage,
                                        title: c.buttonTitle
                                    }, null, 8, ["onClick", "image", "title"])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (n) => {
                            return _createElementVNode("div", {
                                class: _normalizeClass('hubItemWrapper'),
                                key: n
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "card" })
                            ]);
                        }), 64))
                    ])),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (favourites.value && favouriteVouchers.value && !filter.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(VoucherList, {
                                    showFavourites: true,
                                    onFavouriteToggled: _cache[2] || (_cache[2] = (v) => { favouriteToggled(v); }),
                                    vouchers: _unref(state).availableVouchers.filter(v => v.favourite),
                                    showAll: true,
                                    search: false
                                }, null, 8, ["vouchers"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _cache[3] || (_cache[3] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
